import PageTitle from '../PageTitle';
import FormInput from '../FormInput';
import { TranslationHelper } from 'classes/TranslationHelper';
import {
    InsuranceDocumentsList,
    RoutePaths,
    SelectOptionsYesNo
} from 'Constants/Common';
import { ClaimContext } from 'context/ClaimContext';
import { useContext, useEffect, useRef } from 'react';
import { InsuranceDocumentType } from '../CommonTypes';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ClaimNextStepsPage = (): JSX.Element => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const scrollDivRef = useRef<null | HTMLDivElement>(null);

    const { gapClaim, setGapClaim, claimRequest } = useContext(ClaimContext);

    useEffect(() => {
        scrollDivRef.current?.scrollIntoView();

        let insuranceDocuments: InsuranceDocumentType[] =
            InsuranceDocumentsList;

        if (gapClaim.fullCoverage == SelectOptionsYesNo.No)
            insuranceDocuments = insuranceDocuments.filter(
                (i) => i.requiredIfNoInsurance == true
            );
        setGapClaim({
            ...gapClaim,
            requiredDocuments: insuranceDocuments
        });
    }, []);

    const renderDocument = (index: number, documentName: string) => {
        return (
            <li
                key={`document-${index}`}
                className='list-group-item panel-list'>
                {TranslationHelper.getTranslatedText(documentName)}
            </li>
        );
    };

    const onUploadDocumentsClick = (): void => {
        navigate(RoutePaths.ClaimUploadDocuments);
    };

    const onBackButtonClick = (): void => {
        navigate(RoutePaths.Home);
    };

    return (
        <div>
            <div ref={scrollDivRef}></div>
            <div className='card page-content'>
                <PageTitle title={t('claim_next_steps_title')} />
                <div className='p-3 m-0'>
                    <p>{t('claim_submit_request_message')}</p>{' '}
                </div>
                <FormInput
                    id='claim-request-forminput'
                    label={t('claim_request_details')}>
                    {claimRequest && (
                        <div
                            id={`claim-request-`}
                            className='submitted-claim-request'>
                            <b>{t('claim_request_product_reference')}</b>
                            <span>{claimRequest.productReference}</span>
                            <br />
                            <b>{t('claim_request_product_type')}</b>
                            <span>
                                {`${TranslationHelper.getTranslatedText(`${claimRequest.productType}`, 'product_types')}`}
                            </span>
                            <br />
                            <b>{t('claim_request_reference')}</b>
                            <span>{claimRequest.claimRequestReference}</span>
                            <br />
                            <b>{t('claim_request_status')}</b>
                            <span>
                                {TranslationHelper.getTranslatedText(
                                    claimRequest.status
                                )}
                            </span>
                            <br />
                            <b>{t('claim_request_date')}</b>
                            <span>{claimRequest.submittedDate}</span>
                        </div>
                    )}
                </FormInput>
                <FormInput
                    id='documents-forminput'
                    label={t('requested_documents')}>
                    <ul className='list-group list-group-flush'>
                        {gapClaim?.requiredDocuments?.map(
                            (panel, index) =>
                                panel.additionalDocument == false &&
                                renderDocument(index, panel.documentName)
                        )}
                    </ul>
                </FormInput>
                <div className='bottom-navigation'>
                    <button
                        data-testid='primary-button'
                        className='btn btn-primary progress-button'
                        onClick={() => onUploadDocumentsClick()}>
                        {t('upload_documents')}
                    </button>
                    <button
                        aria-label='back-button'
                        className='btn btn-secondary progress-button'
                        onClick={() => onBackButtonClick()}>
                        {t('back')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ClaimNextStepsPage;
